import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'marketo',
  initialState: {
    syncEventsModalOpen: false
  },
  reducers: {
    openSyncEventsModal(state) {
      state.syncEventsModalOpen = true
    },
    closeSyncEventsModal(state) {
      state.syncEventsModalOpen = false
    },
  }
})

export const {
  reducer,
  actions: {
    openSyncEventsModal,
    closeSyncEventsModal
  }
} = slice
